"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var MindthiefIcon = /** @class */ (function (_super) {
    __extends(MindthiefIcon, _super);
    function MindthiefIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MindthiefIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 5.4955613,16.057094 c 0.167059,-0.411217 0.338615,-1.313819 0.345358,-1.817027 0.0056,-0.419663 -0.02225,-0.445686 -0.477423,-0.445686 -1.136758,0 -3.111057,-1.036037 -3.733479,-1.959187 -0.354367,-0.525583 -0.402986,-1.220075 -0.102851,-1.469165 0.299684,-0.248715 0.257087,-0.339169 -0.228819,-0.4858943 -0.54674104,-0.165096 -0.97096604,-0.729966 -0.99242004,-1.321443 -0.0091,-0.250457 -0.09811,-0.5999723 -0.197822,-0.7767003 -0.203367,-0.36043 -0.121742,-0.86874 0.223669,-1.392852 0.124268,-0.18856 0.240685,-0.554029 0.258706,-0.812155 0.01802,-0.258126 0.212857,-0.720954 0.43296804,-1.028506 0.220111,-0.307552 0.442234,-0.752508 0.493608,-0.988792 0.124147,-0.570993 0.914071,-1.474289 1.683653,-1.925294 0.342107,-0.200487 0.761507,-0.504018 0.932003,-0.67451396 0.712335,-0.712335 3.757571,-1.140187 6.2759007,-0.881758 1.15236,0.118255 1.52431,0.218661 2.21695,0.598451 0.45775,0.250996 1.0008,0.49824196 1.20678,0.54943696 0.20597,0.05119 0.57624,0.294242 0.8228,0.540104 0.24657,0.245861 0.7303,0.554388 1.07496,0.685613 0.97424,0.370926 2.56762,2.021431 2.84489,2.946884 0.33337,1.112683 0.066,2.755978 -0.55907,3.4356323 -0.68543,0.745336 -1.85598,1.015689 -2.85349,0.659049 -0.26925,-0.09627 -0.70365,-0.150035 -0.96533,-0.119485 -0.45305,0.05289 -0.47315,0.07806 -0.42074,0.526961 0.075,0.6420113 -0.19623,1.2326563 -0.71178,1.5502913 -0.35417,0.218209 -0.68639,0.264547 -1.89316,0.264053 -0.99262,-4.11e-4 -1.5430202,-0.05866 -1.7103702,-0.181033 -0.21707,-0.15872 -0.27692,-0.130845 -0.49734,0.231602 -0.1378195,0.226622 -0.4265595,0.478466 -0.6416595,0.559655 -0.3106,0.11724 -0.40868,0.257691 -0.47661,0.68253 -0.16958,1.06047 -0.987172,2.224278 -2.195645,3.125401 -0.244033,0.181969 -0.25659,0.175768 -0.154237,-0.07617 z" }))));
    };
    return MindthiefIcon;
}(react_1.Component));
exports.default = MindthiefIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/MindthiefIcon.tsx
// module id = 790
// module chunks = 0